<template>
  <div class="top-products">
    <line-chart :chart-data="charData"></line-chart>
  </div>
</template>

<script>
import LineChart from "@/components/admin/dashboard/charts/LineChart";
import chartMixin from "@/mixins/dashboard/chartMixin";

export default {
  name: "DailyRevenueChart",
  components: { LineChart },
  mixins: [chartMixin],
  props: {
    orders: {
      type: Array,
      default: null
    },
    ordersLastYear: {
      type: Array,
      default: null
    },
    labelDataset1: {
      type: String,
      default: null
    },
    labelDataset2: {
      type: String,
      default: null
    },
    productTypeSelected: {
      type: String,
      default: null
    }
  },
  computed: {
    charData() {
      // Current date selected
      let ordersGrouped = this.groupDailyOrdersByTime(this.orders);

      let labels = [];
      Object.keys(ordersGrouped).forEach(time => {
        labels.push(time);
      });

      let data = [];
      Object.values(ordersGrouped).forEach(orders => {
        let total = orders.reduce((acc, n) => acc + n.totalAmount || 0, 0);
        data.push(parseFloat(total).toFixed(2));
      });

      // Current date last year selected
      let ordersGroupedLastYearPerDay = this.groupDailyOrdersByTime(
        this.ordersLastYear
      );

      let labelsLastYearPerDay = [];
      Object.keys(ordersGroupedLastYearPerDay).forEach(time => {
        labelsLastYearPerDay.push(
          `${this.dayFormatChart(time)} ${this.formatTime(time)}`
        );
      });

      let dataLastYearPerDay = [];
      Object.values(ordersGroupedLastYearPerDay).forEach(orders => {
        let total = orders.reduce((acc, n) => acc + n.totalAmount || 0, 0);
        dataLastYearPerDay.push(parseFloat(total).toFixed(2));
      });

      return {
        labels: labels,
        datasets: [
          {
            label: this.labelDataset1,
            backgroundColor: "#fc4d4d",
            borderColor: "red",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "white",
            data: data
          },
          {
            label: this.labelDataset2,
            backgroundColor: "#caf7fd",
            borderColor: "#02e0fd",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "white",
            data: dataLastYearPerDay
          }
        ]
      };
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
